import script from "./BookingApp.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingApp.vue?vue&type=script&setup=true&lang=js"

import "./BookingApp.vue?vue&type=style&index=0&id=228d5fee&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-228d5fee"]])

export default __exports__